module.exports = __webpack_public_path__ + "static/NeuralNetworksDeepLearningCert-a917cde4ed7292ad76eb256ba8e78831.jpg";